"use client";

import { c as _c } from "react/compiler-runtime";
import React, { createContext, useContext, useState, useEffect, useCallback } from "react";
import { getConsent, setConsent } from "./consent-utils";
import type { ConsentState, ConsentContextValue } from "./types";
const ConsentContext = createContext<ConsentContextValue | null>(null);
interface ConsentProviderProps {
  children: React.ReactNode;
}
export function ConsentProvider(t0) {
  const $ = _c(13);
  const {
    children
  } = t0;
  const [consent, setConsentState] = useState(null);
  const [isLoaded, setIsLoaded] = useState(false);
  const [isPreferencesOpen, setIsPreferencesOpen] = useState(false);
  let t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => {
      setConsentState(getConsent());
      setIsLoaded(true);
    };
    t2 = [];
    $[0] = t1;
    $[1] = t2;
  } else {
    t1 = $[0];
    t2 = $[1];
  }
  useEffect(t1, t2);
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = (analytics, marketing) => {
      const newState = setConsent(analytics, marketing);
      setConsentState(newState);
      setIsPreferencesOpen(false);
    };
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  const updateConsent = t3;
  let t4;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = () => {
      updateConsent(true, true);
    };
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  const acceptAll = t4;
  let t5;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = () => {
      updateConsent(false, false);
    };
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  const rejectAll = t5;
  let t6;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = () => {
      setIsPreferencesOpen(true);
    };
    $[5] = t6;
  } else {
    t6 = $[5];
  }
  const openPreferences = t6;
  let t7;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = () => {
      setIsPreferencesOpen(false);
    };
    $[6] = t7;
  } else {
    t7 = $[6];
  }
  const closePreferences = t7;
  const t8 = isLoaded ? consent : null;
  let t9;
  if ($[7] !== isPreferencesOpen || $[8] !== t8) {
    t9 = {
      consent: t8,
      isPreferencesOpen,
      updateConsent,
      acceptAll,
      rejectAll,
      openPreferences,
      closePreferences
    };
    $[7] = isPreferencesOpen;
    $[8] = t8;
    $[9] = t9;
  } else {
    t9 = $[9];
  }
  const value = t9;
  let t10;
  if ($[10] !== children || $[11] !== value) {
    t10 = <ConsentContext.Provider value={value}>{children}</ConsentContext.Provider>;
    $[10] = children;
    $[11] = value;
    $[12] = t10;
  } else {
    t10 = $[12];
  }
  return t10;
}

/**
 * Hook to access consent state in client components.
 * Must be used within a ConsentProvider.
 */
export function useConsent() {
  const context = useContext(ConsentContext);
  if (!context) {
    throw new Error("useConsent must be used within a ConsentProvider");
  }
  return context;
}